"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedFolderWithAncestors = exports.getIsBrowsingFolder = exports.getParentFolderForSelectFile = exports.getSelectedStockFile = exports.getSelectedFileInPanel = exports.getSelectedFileId = exports.getSearchQuery = exports.getSelectedFolderInPanel = exports.getActivePanel = exports.getPreviousPanel = exports.getPanelType = void 0;

var _reselect = require("reselect");

var _immutable = require("immutable");

var _Folders = require("FileManagerCore/selectors/Folders");

var _FoldersAndFiles = require("FileManagerCore/utils/FoldersAndFiles");

var _FileDetails = require("FileManagerCore/selectors/FileDetails");

var _fileFiltering = require("../utils/fileFiltering");

var _Filter = require("./Filter");

var _Configuration = require("./Configuration");

var getPanelType = function getPanelType(state, props) {
  return props.type;
};

exports.getPanelType = getPanelType;

var getPanel = function getPanel(state) {
  return state.panel.get('present');
};

var getPreviousPanel = function getPreviousPanel(state) {
  return state.panel.get('past').last();
};

exports.getPreviousPanel = getPreviousPanel;

var getActivePanel = function getActivePanel(state) {
  return state.panel.getIn(['present', 'activePanel']);
};

exports.getActivePanel = getActivePanel;

var getSelectedFolderInPanel = function getSelectedFolderInPanel(state) {
  return state.panel.getIn(['present', 'selectedFolder']);
};

exports.getSelectedFolderInPanel = getSelectedFolderInPanel;
var getSelectedFile = (0, _reselect.createSelector)([getPanel], function (panel) {
  return panel.get('selectedFile');
});
var getSearchQuery = (0, _reselect.createSelector)([getPanel], function (panel) {
  return panel.get('searchQuery');
});
exports.getSearchQuery = getSearchQuery;
var getSelectedFileId = (0, _reselect.createSelector)([getPanel], function (panel) {
  return panel.getIn(['selectedFile', 'id']);
});
exports.getSelectedFileId = getSelectedFileId;
var getSelectedFileInPanel = (0, _reselect.createSelector)([getSelectedFile, _FileDetails.getSingleFileDetails, _Filter.getFilter, _Configuration.getIsHostAppContextPrivate], function (selectedFile, singleFileDetails, filter, isHostAppContextPrivate) {
  if (!selectedFile) {
    return null;
  }

  var selectedFileId = selectedFile.get('id');
  var full_path = selectedFile.get('full_path');
  var file = singleFileDetails.get(selectedFileId) || selectedFile;
  return (0, _fileFiltering.addSupportInfoToFiles)(_immutable.List.of(file.merge({
    full_path: full_path
  })), filter, isHostAppContextPrivate).first();
});
exports.getSelectedFileInPanel = getSelectedFileInPanel;

var getSelectedStockFile = function getSelectedStockFile(state) {
  return state.panel.getIn(['present', 'selectedStockFile']);
};

exports.getSelectedStockFile = getSelectedStockFile;
var getParentFolderForSelectFile = (0, _reselect.createSelector)([getSelectedFileInPanel, _Folders.getFoldersById], function (selectedFile, folders) {
  return (0, _FoldersAndFiles.getParentFolder)(selectedFile, folders);
});
exports.getParentFolderForSelectFile = getParentFolderForSelectFile;
var getIsBrowsingFolder = (0, _reselect.createSelector)([getSelectedFolderInPanel], function (selectedFolder) {
  return Boolean(selectedFolder && selectedFolder.get('id'));
});
exports.getIsBrowsingFolder = getIsBrowsingFolder;
var getSelectedFolderWithAncestors = (0, _reselect.createSelector)([getSelectedFolderInPanel, _Folders.getFoldersById], function (selectedFolder, folders) {
  if (!selectedFolder) {
    return (0, _immutable.List)();
  }

  if (!selectedFolder.get('id')) {
    return _immutable.List.of((0, _FoldersAndFiles.getHomeFolder)());
  }

  return _immutable.List.of((0, _FoldersAndFiles.getHomeFolder)()).concat((0, _FoldersAndFiles.getAncestors)(selectedFolder, folders).toList());
});
exports.getSelectedFolderWithAncestors = getSelectedFolderWithAncestors;